import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

export const Home = () => {
    const [imgData, setImgData] = useState([])
    useEffect(() => {
        document.title = 'Abhinav - Home';
    }, []);
    return (
        <div className="container">
            <div className="section-mid">
                <h2 className='c-heading ft-w-medium'>Welcome to My Game Dev Universe!</h2>

                <p class="paragraph">
                Hey! I’m Abhinav - a Unity Developer who genuinely enjoys turning ideas into playable experiences. Over the past 3+ years, I’ve worked on both personal and commercial game projects, building gameplay systems, UI, tools, and polished player experiences across multiple platforms. Some projects were solo experiments, while others came together through late-night teamwork, testing mechanics, fixing bugs, and refining every little detail until the game finally felt right.
                </p>

                <p class="paragraph">
                Professionally, I’ve contributed to 15+ live games and continue exploring new areas of game development, especially performance optimization, gameplay architecture, runtime content systems, and cross-platform workflows in Unity. Recently, I’ve also been diving deeper into 3D development, shaders, lighting, and scene composition to better understand how great-looking worlds are built and optimized.
                </p>

                <p class="paragraph">
                What I enjoy most is the problem-solving side of development - profiling difficult issues, improving gameplay feel, designing scalable systems, and making experiences run smoothly across a wide range of devices, from mobile phones to desktop platforms.
                </p>

                <p class="paragraph">
                Outside of development, I enjoy gaming, traveling, and exploring topics around science, technology, and space. I’m always curious about how things work, which naturally carries over into the way I build games and experiment with new ideas.
                </p>

                <p class="paragraph">
                Feel free to explore some of my projects below - and if you’d like to collaborate, discuss game development, or build something interesting together, I’d be happy to connect.
                </p>

            </div>

            {/* 
            <div class="section-mid">
                <h2 class="c-heading ft-w-medium">Beyond the Code</h2>

                <p class="paragraph">When I’m not coding, I’m strategizing on the cricket field, diving into tech books, or mentoring aspiring developers. These passions fuel my creativity and sharpen my teamwork and problem-solving skills, ensuring I bring fresh ideas and clear communication to every game project. Let’s collaborate to build your next big game-reach out today!</p>
            </div> */}


        </div>
    )
}
